"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleComponentWebsiteRender = exports.TitleComponentEditor = exports.TitleComponentCreator = exports.TitleComponentRender = void 0;
const react_1 = __importDefault(require("react"));
// import { AiOutlineOrderedList } from 'react-icons/ai'
const react_bootstrap_1 = require("react-bootstrap");
const structure_1 = require("./structure");
function TitleComponentRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const render = props.render;
    const style = component.style;
    const className = props.className;
    let text;
    switch (render) {
        case 'original':
            text = react_1.default.createElement("h1", { dir: originalDir, className: 'text-center' }, component.original);
            break;
        case 'translated':
            text = react_1.default.createElement("h1", { dir: translatedDir, className: 'text-center' }, component.translated);
            break;
        case 'both':
            text = react_1.default.createElement("div", { style: style },
                react_1.default.createElement("h1", { dir: originalDir, className: 'text-center' }, component.original),
                react_1.default.createElement("h1", { dir: translatedDir, className: 'text-center' }, component.translated));
            break;
        default:
            text = react_1.default.createElement("h1", { dir: originalDir, className: 'text-center' }, component.original);
            break;
    }
    return react_1.default.createElement("div", { className: className }, text);
}
exports.TitleComponentRender = TitleComponentRender;
function TitleComponentCreator(props) {
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState('');
    const [translated, settranslated] = react_1.default.useState('');
    return react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0627\u0635\u0644\u064A" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", style: { height: '100px' }, onChange: (e) => {
                    setoriginal(e.target.value);
                    dispatch((0, structure_1.titleObject)(e.target.value, translated));
                } })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u062A\u0631\u062C\u0645" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", style: { height: '100px' }, onChange: (e) => {
                    settranslated(e.target.value);
                    dispatch((0, structure_1.titleObject)(original, e.target.value));
                } })));
}
exports.TitleComponentCreator = TitleComponentCreator;
function TitleComponentEditor(props) {
    const component = props.component;
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState(component.original);
    const [translated, settranslated] = react_1.default.useState(component.translated);
    const popover = (react_1.default.createElement(react_bootstrap_1.Popover, { id: "popover-basic" },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u062A\u0631\u062C\u0645"),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u062A\u0631\u062C\u0645" }))));
    return (react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement("input", { style: {
                backgroundColor: 'white',
                textAlign: 'center',
                borderWidth: 0,
                width: '100%',
                fontSize: 40,
                fontWeight: 'bold'
            }, onChange: (e) => {
                setoriginal(e.target.value);
                dispatch((0, structure_1.titleObject)(e.target.value, translated));
            }, value: original }),
        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", onChange: (e) => {
                settranslated(e.target.value);
                dispatch((0, structure_1.titleObject)(original, e.target.value));
            }, value: translated !== null && translated !== void 0 ? translated : '', style: { width: 900 } })));
}
exports.TitleComponentEditor = TitleComponentEditor;
function TitleComponentWebsiteRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const render = props.render;
    const className = props.className;
    const style = component.style;
    // return <div >
    //     <h1 dir={translatedDir} className='text-center'>{component.translated}</h1>
    // </div >
    let text;
    switch (render) {
        case 'original':
            text = react_1.default.createElement("h1", { dir: originalDir, className: 'text-center' }, component.original);
            break;
        case 'translated':
            text = react_1.default.createElement("h1", { dir: translatedDir, className: 'text-center' }, component.translated);
            break;
        case 'both':
            text = react_1.default.createElement("div", { style: style },
                react_1.default.createElement("h1", { dir: originalDir, className: 'text-center' }, component.original),
                react_1.default.createElement("h1", { dir: translatedDir, className: 'text-center' }, component.translated));
            break;
        default:
            text = react_1.default.createElement("h1", { dir: originalDir, className: 'text-center' }, component.original);
            break;
    }
    return react_1.default.createElement("div", { className: className }, text);
}
exports.TitleComponentWebsiteRender = TitleComponentWebsiteRender;
